import React, { useEffect, useState } from "react";
import { Layout, theme } from "antd";
import Sider from "antd/es/layout/Sider";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { CompHeader, SideMenu } from "../components";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { checkRouteName } from "../utills";
const { Header, Content, Footer } = Layout;
export const ProtectedLayout = () => {
  const isLogin = useSelector((state) => state.AuthReducer.isLogin);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { height, width } = useWindowDimensions();
  const location = useLocation();
  if (isLogin == false) {
    // navigate('/login');
    return <Navigate to={"/"} />;
  }
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      hasSider
      style={{
        backgroundColor: "var(--black-color)",
      }}
    >
      <Sider
        trigger={null}
        collapsible
        width={230}
        collapsed={width > 768 ? collapsed : true}
        style={{
          backgroundColor: "var(--primary-color)",
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          overflowX: "hidden",
          transition: "width 2s ease 2s",
          // marginLeft: collapsed && 15,
        }}
      >
        <SideMenu
          collapsed={collapsed}
          onBackClick={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Layout
        className="site-layout"
        style={{
          marginLeft: width > 768 ? (collapsed ? 80 : 220) : 80,
          backgroundColor: "var(--black-color)",
          minHeight: "100vh",
          // transition: 'width 2s'
        }}
      >
        <Header
          style={{ padding: 0, background: "var(--black-color)", height: 100 }}
        >
          <CompHeader
            onBackClick={() => setCollapsed(!collapsed)}
            collapsed={collapsed}
            title={checkRouteName(location.pathname?.substring(1))}
          />
        </Header>
        <Content
          style={{
            margin: "10px 4px",
            padding: width > 768 ? 24 : 0,
            minHeight: 650,
            background: "var(--black-color)",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
